import { Component, OnInit } from '@angular/core';
import { LookupScreenService } from '../../../../../../services/lookup-screen.service';
import { ActivatedRoute, Router } from '@angular/router';
import { LazyLoadEvent } from 'primeng/api';
import { DoctorBreadcrumbService } from '../../../../shared/breadcrumb.service';
import { Title } from '@angular/platform-browser';
import { TraceClassDecorator } from '@sentry/angular';
import { searchBody } from '../lookup-search-p/lookup-search-p.component';
import { JsonDataService } from 'src/app/services/json-data.service';
import { ProviderStateService } from 'src/app/services/provider-state.service';

@TraceClassDecorator()
@Component({
    selector: 'app-lookup-list-p',
    templateUrl: './lookup-list-p.component.html',
    styleUrls: [
        './lookup-list-p.component.css',
        '../../../../../../../assets/css/custom-egd.css'
    ]
})
export class LookupListPComponent implements OnInit {
    body: any;

    gtype: any;
    lookuplist;
    multirecord: any;
    selectedPatient;
    type;
    data: string;
    e;
    first = 1;
    gpageNo = 0;
    pageno;
    rows = 1;
    totalRecords: number;
    loading: boolean = false;
    cols: any[];
    slug: string = "";
    searchbody1: searchBody = {
        current_user_guid: '',
        records_per_page: 0,
        page_no: 0
    };
    searchBody: { current_user_guid: string; e_email: string; medical_record_number: string; mobile_number: string; records_per_page: number; page_no: number; };
    constructor(
        private readonly lookupservice: LookupScreenService,
        private readonly router: Router,
        private readonly titleService: Title,
        private route: ActivatedRoute,
        private readonly breadcrumbService: DoctorBreadcrumbService,
        private readonly providerstateService: ProviderStateService
    ) {

    }

    getpage(gtype, gdata, grow: number = 1, first: number = 1) {
        this.pageno = (first - 1) / grow + 1;
        switch (gtype) {
            case 'mrn':
                this.body = {
                    medical_record_number: gdata,
                    records_per_page: grow.toString(),
                    page_no: this.pageno.toString()
                };
                break;
            case 'email':
                this.body = {
                    e_email: gdata,
                    records_per_page: grow.toString(),
                    page_no: this.pageno.toString()
                };
                break;
            case 'phone':
                this.body = {
                    mobile_number: gdata,
                    records_per_page: grow.toString(),
                    page_no: this.pageno.toString()
                };
                break;
        }

        this.lookupservice
            .searchPersonalDetails(this.body)
            .then((sdata) => {
                if (sdata == true) {
                    this.getDetails();
                }
            })
            .catch((error) => {
                this.e = error.error;
            });
    }

    selectPatient(lookup) {

        this.selectedPatient = lookup;
        this.lookupservice.setSelectedPatient(this.selectedPatient);
        this.router.navigate(['/' + this.slug + '/doctor/lookup-display-p'], { queryParams: { p_guid: this.selectedPatient.patient_guid } });
    }

    ngOnInit(): void {
        this.slug = this.providerstateService.getProviderSlug();
        this.breadcrumbService.setItems([
            { label: 'Dashboard', routerLink: [`/${this.slug}/doctor`] },
            { label: 'Lookup Screen' },
            { label: 'Lookup Patients Search' },
            { label: 'Lookup Patients List' }
        ]);
        this.titleService.setTitle('Dashboard - Patient Lookup List');

        /*this.route.params.subscribe((params) => {
            this.type = params['searchType'];
            this.data = params['searchData'];
        });*/

        this.cols = [
            { field: 'medical_record_number', header: 'MRN' },
            { field: 'first_name', header: 'First Name' },
            /*   {field: 'middle_name', header: 'Middle Name'}, */
            { field: 'last_name', header: 'Last Name' },
            { field: 'user_patient.users.e_email', header: 'Email' },
            { field: 'account_status', header: 'Status' },
            { field: 'check', header: 'Check' }
        ];

        this.route.queryParamMap.subscribe(async (res) => {
            let searchType = res.get('searchType');
            let searchdata = res.get('searchData');
            this.searchbody1.current_user_guid = sessionStorage.getItem('userid');
            this.searchbody1.page_no = 1;
            this.searchbody1.records_per_page = 100;
            if (searchType === 'e_email') {
                this.searchbody1.e_email = searchdata;
            }
            if (searchType === 'medical_record_number') {
                this.searchbody1.medical_record_number = searchdata;
            }
            if (searchType === 'mobile_number') {
                this.searchbody1.mobile_number = searchdata;
            }

        });


        this.lookupservice
            .searchPersonalDetails(this.searchbody1)
            .then((resp) => {
                if (resp.data.patient.count > 0) {
                    this.getDetails();
                } else {
                    this.e = "No Record Found !!"
                }
            })
            .catch((error) => (this.e = error.error.message));



    }

    getDetails() {
        this.loading = true;
        this.lookuplist = this.lookupservice.displayDetails();
        this.totalRecords = this.lookuplist.data.patient.count;
        this.multirecord = [...this.lookuplist.data.patient.rows];
        this.loading = false;
    }

    loadCustomers(event: LazyLoadEvent) {
        this.loading = true;
        setTimeout(() => {
            if (this.multirecord) {
                this.getpage(this.type, this.data, event.rows, event.first + 1);
                this.loading = false;
            }
        }, 1000);
    }

    prev() {
        this.router.navigate(['/' + this.slug + '/doctor/lookup-search-p']);
    }
}
